<template>
  <div class="page-container">
    <el-collapse v-model="collapseName">
      <el-collapse-item name="baseInfo">
        <template slot="title">
          <span class="header-title">运单基本信息</span> 
        </template>  
          <el-row :gutter="20" style="padding:10px 4px">
            <el-col :span="4"><div><span>运单编号</span><p>{{waybillInfo.waybillNo}}</p></div></el-col>
            <el-col :span="4"><div><span>预约单编号</span><p>{{waybillInfo.bookingNo}}</p></div></el-col>
            <el-col :span="4"><div><span>运单状态</span><p style="color:red">{{waybillInfo.statusDesc}}</p></div></el-col>
            <el-col :span="4"><div><span>煤矿</span><p>{{waybillInfo.coalMineName}}</p></div></el-col>
            <el-col :span="4"><div><span>采购方</span><p>{{waybillInfo.purchaseName}}</p></div></el-col>
            <el-col :span="4"><div><span>采购方父账号</span><p v-if="waybillInfo.purchaseNo!=waybillInfo.purchaseParentNo">{{waybillInfo.purchaseParentName}}</p></div></el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="4"><div><span>车牌号</span><p>{{waybillInfo.carLicensePlateNo}}</p></div></el-col>
            <el-col :span="4"><div><span>司机姓名</span><p>{{waybillInfo.driverName}}</p></div></el-col>
            <el-col :span="4"><div><span>司机手机号</span><p>{{waybillInfo.driverPhone}}</p></div></el-col>
            <el-col :span="4"><div><span>司机身份证</span><p>{{waybillInfo.driverIdCard}}</p></div></el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="4"><div><span>煤种</span><p>{{waybillInfo.coalCategoryName }}</p></div></el-col>
            <el-col :span="4"><div><span>煤种单价(元/吨)</span><p>{{waybillInfo.unitPrice}}</p></div></el-col>
            <el-col :span="4"><div><span>销售价格(元)</span><p>{{waybillInfo.goodsPrice }}</p></div></el-col>
            <el-col :span="4"><div><span>煤检票类型</span><p>{{waybillInfo.mjpType}}</p></div></el-col>
            <el-col :span="4"><div><span>车辆预载值（吨）</span><p>{{waybillInfo.preLoadVal}}</p></div></el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="4"><div><span>装货地址</span><p>{{waybillInfo.loadingAddress}}</p></div></el-col>
            <el-col :span="4"><div><span>卸货地址</span><p>{{waybillInfo.unloadingAddress}}</p></div></el-col>
            <el-col :span="4"><div><span>运费(元/吨)</span><p>{{waybillInfo.transportPrice}}</p></div></el-col>
            <el-col :span="4"><div><span>承运单位</span><p>{{waybillInfo.acceptCompany}}</p></div></el-col>
            <el-col :span="4"><div><span>卸煤地点</span><p>{{waybillInfo.unloadingCoalAddress}}</p></div></el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="4"><div><span>派单类型</span><p>{{waybillInfo.dispatchTypeDesc}}</p></div></el-col>
            <el-col :span="4"><div><span>入场方式</span><p>{{waybillInfo.enterParkWayDesc}}</p></div></el-col>
            <el-col :span="4"><div><span>超时入场</span><p>{{waybillInfo.timeoutEnterPark== 0 ? "否" : "是"}}</p></div></el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="4"><div><span>系统开单费(元)</span><p>{{waybillInfo.openWaybillPrice}}</p></div></el-col>
            <el-col :span="4"><div><span>系统使用费(元)</span><p>{{waybillInfo.systemUsePrice ? (waybillInfo.systemUsePrice/100).toFixed(2) : 0 }}</p></div></el-col>
            <el-col :span="4"><div><span>缴费状态</span><p>{{waybillInfo.transStatusDesc}}</p></div></el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="4"><div><span>采购类型</span><p>{{purchaseTypeObj[waybillInfo.purchaseType] }}</p></div></el-col>
            <el-col :span="4"><div><span>发运主体</span><p>{{ waybillInfo.dispatchSubjectNo ?  dispatchSubject[waybillInfo.dispatchSubjectNo] :'' }}</p></div></el-col>
            <el-col :span="4"><div><span>运费结算状态</span><p>{{ waybillInfo.settleStatusDesc }}</p></div></el-col>
            <el-col :span="4"><div><span>建议运费(元)</span><p>{{ waybillInfo.suggestCarriage }}</p></div></el-col>
            <el-col :span="4"><div><span>实结运费(元)</span><p>{{ waybillInfo.realAmount }}</p></div></el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="4"><div><span>小保当采购合同编号</span><p>{{waybillInfo.gtContractId}}<el-button v-if="waybillInfo.gtContractId" size="small" type="text" @click="getContractDetail">详情</el-button></p></div></el-col> 
            <el-col :span="4"><div><span>小保当运单编号</span><p>{{waybillInfo.gtWbNo}}<el-button  v-if="waybillInfo.gtWbNo"  size="small" type="text" @click="getGTwaybillNo">详情</el-button></p></div></el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="4"><div><span>矿发毛重</span><p>{{waybillInfo.grossWeight}}</p></div></el-col>
            <el-col :span="4"><div><span>矿发皮重</span><p>{{waybillInfo.tareWeight}}</p></div></el-col>
            <el-col :span="4"><div><span>矿发净重</span><p>{{waybillInfo.netWeight}}</p></div></el-col>
            <el-col :span="4"><div><span>矿发票据单号</span><p>{{waybillInfo.mindBillNo}}</p></div></el-col>
            <el-col :span="4"><div><span>矿发票据时间</span><p>{{waybillInfo.mindBillTime}}</p></div></el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="6"><div>
              <span>矿发图片</span>  
              <p style="display:flex"><el-image
              class="voucher"
              v-if="waybillInfo.mineImageUrl1"
              :src="waybillInfo.mineImageUrl1"
              :preview-src-list="[
                waybillInfo.mineImageUrl1,
                waybillInfo.mineImageUrl2,
              ]"
            ></el-image>
            <el-image
              class="voucher"
              v-if="waybillInfo.mineImageUrl2"
              :src="waybillInfo.mineImageUrl2"
              :preview-src-list="[
                waybillInfo.mineImageUrl1,
                waybillInfo.mineImageUrl2,
              ]"
            ></el-image></p>
            </div></el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="4"><div><span>到站毛重</span><p>{{waybillInfo.arriveStationGrossWeight}}</p></div></el-col>
            <el-col :span="4"><div><span>到站皮重</span><p>{{waybillInfo.arriveStationTareWeight}}</p></div></el-col>
            <el-col :span="4"><div><span>到站净重</span><p>{{waybillInfo.arriveStationNetWeight}}</p></div></el-col>
            <el-col :span="4"><div><span>到站票据单号</span><p>{{waybillInfo.arriveBillNo}}</p></div></el-col>
            <el-col :span="4"><div><span>到站票据时间</span><p>{{waybillInfo.arriveBillTime}}</p></div></el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="4"><div><span>到站过磅单号</span><p>{{waybillInfo.arriveStationPoundNo}}</p></div></el-col>
            <el-col :span="4"><div><span>是否矫正</span><p>{{waybillInfo.arriveStationAdjustWeightFlag == 0 ?"否":"是"}}</p></div></el-col>
            <el-col :span="4"><div><span>矫正历史</span><p><el-popover placement="right" width="400" trigger="click">
              <el-timeline v-if="historyAxis.length > 0">
                <el-timeline-item
                  v-for="(item, index) in historyAxis"
                  :key="index"
                  :color="item.color"
                  :timestamp="item.timestamp"
                >
                  <p class="historyItem-title">矫正前：</p>
                  <p
                    class="historyItem"
                    v-for="n in item.modifyBefore"
                    :key="n.name"
                  >
                    {{ n.desc }}：{{ n.value }}吨
                  </p>
                  <p class="historyItem-title">矫正后：</p>
                  <p
                    class="historyItem"
                    v-for="(n, i) in item.modifyAfter"
                    :key="i"
                  >
                    {{ n.desc }}：{{ n.value }}吨
                  </p>
                </el-timeline-item>
              </el-timeline>
              <div v-else>暂无数据</div>
              <el-button
                type="text"
                slot="reference"
                size="mini"
                @click="handleGetAdjustHistory"
                >查看</el-button
              >
            </el-popover></p></div></el-col>
            
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="6"><div>
              <span>到站图片</span>  
              <p style="display:flex"><el-image
              class="voucher"
              v-if="waybillInfo.arriveStationImageUrl1"
              :src="waybillInfo.arriveStationImageUrl1"
              :preview-src-list="[
                waybillInfo.arriveStationImageUrl1,
                waybillInfo.arriveStationImageUrl2,
              ]"
            ></el-image>
            <el-image
              class="voucher"
              v-if="waybillInfo.arriveStationImageUrl2"
              :src="waybillInfo.arriveStationImageUrl2"
              :preview-src-list="[
                waybillInfo.arriveStationImageUrl1,
                waybillInfo.arriveStationImageUrl2,
              ]"
            ></el-image></p>
            </div></el-col>
          </el-row>
          <el-divider></el-divider>
      </el-collapse-item>  
      <el-collapse-item name="timeAxis">
        <template slot="title">
          <span class="header-title">运单时间轴</span> 
        </template> 
        <div style="padding:10px 8px">
          <el-timeline v-if="timeAxis.length > 0">
                <el-timeline-item
                  v-for="(item, index) in timeAxis"
                  :key="index"
                  :color="item.color"
                  :timestamp="item.timestamp"
                >
                  {{ item.content }}
                </el-timeline-item>
              </el-timeline>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog :visible.sync="isShowPurchaseDetail" v-if="isShowPurchaseDetail" width="500px" :close-on-click-modal="false" title="合同详情">
        <el-form label-width="130px" size="small" :model="bindForm">
          <el-form-item label="采购合同编号：">
            <el-input v-model="waybillInfo.gtContractId" disabled></el-input>
          </el-form-item>
          <el-form-item label="煤种：">
            <span>{{bindForm.coalTypeName}}</span>
          </el-form-item>
          <el-form-item label="合同完成量/配额：">
            <span>{{bindForm.contractFinishedAmount}}/{{bindForm.contractTotal}}吨</span>
          </el-form-item>
          <el-form-item label="合同开始时间：">
            <span>{{bindForm.contractStartTime.replace(/T/g,' ')}}</span>
          </el-form-item>
          <el-form-item label="合同结束时间：">
            <span>{{bindForm.contractEndTime.replace(/T/g,' ')}}</span>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button size="small" @click="isShowPurchaseDetail= false">关 闭</el-button>
        </span>
    </el-dialog>
    <el-dialog :visible.sync="isShowWaybillDetail" width="450px" :close-on-click-modal="false" title="小保当运单详情">
      <el-form label-width="130px" size="small" :model="gtWaybillNoDetail">
        <el-form-item label="广通运单编号：">
          <el-input v-model="waybillInfo.gtWbNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="运单当前状态：">
          <span>{{gtWaybillNoDetail.status}}</span><el-button type="text" icon="el-icon-refresh" @click="handleRefreshStatus"></el-button>
        </el-form-item>
        <el-form-item label="车型：">
          <span>{{gtWaybillNoDetail.carType}}</span>
        </el-form-item>
        <el-form-item label="矿发毛重：">
          <span>{{gtWaybillNoDetail.wbGrossWeight}}吨</span>
        </el-form-item>
        <el-form-item label="矿发皮重：">
          <span>{{gtWaybillNoDetail.wbTareWeight}}吨</span>
        </el-form-item>
        <el-form-item label="矿发净重：">
          <span>{{gtWaybillNoDetail.wbNetWeight}}吨</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="isShowWaybillDetail=false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {dispatchSubject ,purchaseTypeObj} from '@/utils/instance.js'

export default {
  data(){
    return {
      waybillNo:'',
      collapseName:['timeAxis','baseInfo'],
      waybillInfo:{},
      historyAxis:[],
      timeAxis:[],
      dispatchSubject,
      purchaseTypeObj,
      isShowPurchaseDetail:false,
      isShowWaybillDetail:false,
      bindForm:{},
      gtWaybillNoDetail:{

      }
    }
  },
  created(){
    this.getDetail()
    this.getTimeAxis()
  },
  methods:{
    getReturn(){
      this.$router.back()
    },
    getDetail(){
      let params = {
        pageNo:1,
        pageSize:10
      }
      params["searchFieldList[0].fieldName"] = 'waybillNo'
      params["searchFieldList[0].singleValue"] = this.$route.query?.id
      this.$api.waybill.getWaybillDetail({
        waybillNo:this.$route.query?.id
      }).then((res) => {
        this.waybillInfo =res.data
      })
    },
    async getTimeAxis() {
      let res = await this.$api.waybill.getTimeAxis({
        waybillNo: this.$route.query?.id
      });

      if (res.data.length > 0) {
        res.data[0]["color"] = "#0bbd87";
      }
      this.timeAxis = res.data;
    },
    async handleGetAdjustHistory() {
      let params = {
        pageNo: 1,
        pageSize: 1000,
        operationModule: 6,
        operationType: 16,
      }
      params["searchFieldList[0].fieldName"] = "dataPk";
      params["searchFieldList[0].singleValue"] = this.$route.query?.id
      let res = await this.$api.waybill.getAdjustHistory(params);
      const historyAxis = [];
      if (res.data && res.data.dtoList) {
        res.data.dtoList.forEach((n) => {
          historyAxis.push({
            timestamp: n.operationTime,
            modifyBefore: JSON.parse(n.modifyBeforeJson),
            modifyAfter: JSON.parse(n.modifyAfterJson),
          });
        });
      }
      if (historyAxis.length > 0) {
        historyAxis[0]["color"] = "#0bbd87";
      }
      this.historyAxis = historyAxis;
    },
    handleRefreshStatus(){
      this.getGTwaybillNo()
    },
    getContractDetail(){
      this.$api.waybill.getContractDetail({
        contractId:this.waybillInfo.gtContractId
      }).then((res) => {
        this.bindForm = res.data
        this.isShowPurchaseDetail = true
      })
    },
    getGTwaybillNo(){
      this.$api.waybill.getGTwaybillNoDetail({
        gtWbNo:this.waybillInfo.gtWbNo ||'q2021120913101443295655'
      }).then((res) => {
        this.gtWaybillNoDetail = res.data
        this.isShowWaybillDetail = true
      })
      
    }

  },
  
  
}
</script>

<style lang="scss" scoped>
.page-container{
  padding: 10px;
}
::v-deep .el-divider--horizontal{
  margin: 10px 0;
}
.header{
  padding: 10px 0;
}
.header-title{
  padding-left: 10px;
  font-size: 16px;
  font-weight: bold;
}
::v-deep .el-collapse-item__header{
  background: #eee;
  border-radius: 10px;
}
</style>